"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpErrorType = exports.EmailVerificationStatus = exports.PhoneVerificationStatus = exports.OtpVerificationChannel = exports.PhoneVerificationChannel = exports.Gender = exports.UserStatus = exports.UserAccountType = exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType["Member"] = "Member";
    UserType["Client"] = "Client";
})(UserType = exports.UserType || (exports.UserType = {}));
var UserAccountType;
(function (UserAccountType) {
    UserAccountType["member"] = "member";
    UserAccountType["enterprise"] = "enterprise";
})(UserAccountType = exports.UserAccountType || (exports.UserAccountType = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["Pending"] = "Pending";
    UserStatus["Active"] = "Active";
    UserStatus["Disabled"] = "Disabled";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var Gender;
(function (Gender) {
    Gender["male"] = "Male";
    Gender["female"] = "Female";
    Gender["other"] = "Other";
})(Gender = exports.Gender || (exports.Gender = {}));
var PhoneVerificationChannel;
(function (PhoneVerificationChannel) {
    PhoneVerificationChannel["PhoneCall"] = "PhoneCall";
    PhoneVerificationChannel["SMS"] = "SMS";
})(PhoneVerificationChannel = exports.PhoneVerificationChannel || (exports.PhoneVerificationChannel = {}));
;
var OtpVerificationChannel;
(function (OtpVerificationChannel) {
    OtpVerificationChannel["SMS"] = "SMS";
    OtpVerificationChannel["Email"] = "Email";
})(OtpVerificationChannel = exports.OtpVerificationChannel || (exports.OtpVerificationChannel = {}));
;
var PhoneVerificationStatus;
(function (PhoneVerificationStatus) {
    PhoneVerificationStatus["Pending"] = "Pending";
    PhoneVerificationStatus["Verified"] = "Verified";
})(PhoneVerificationStatus = exports.PhoneVerificationStatus || (exports.PhoneVerificationStatus = {}));
;
var EmailVerificationStatus;
(function (EmailVerificationStatus) {
    EmailVerificationStatus["Pending"] = "Pending";
    EmailVerificationStatus["Verified"] = "Verified";
})(EmailVerificationStatus = exports.EmailVerificationStatus || (exports.EmailVerificationStatus = {}));
;
var OtpErrorType;
(function (OtpErrorType) {
    OtpErrorType["InvalidOtpChannelSpec"] = "InvalidOtpChannelSpec";
})(OtpErrorType = exports.OtpErrorType || (exports.OtpErrorType = {}));
//# sourceMappingURL=newUser.js.map